import CloseIcon from '@mui/icons-material/Close'
import PictureInPictureIcon from '@mui/icons-material/PictureInPicture'
import { Box, IconButton, useTheme } from '@mui/material'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../store/Hooks'
import { changeRoute } from '../../store/slices/SessionSlice'
import { Route } from '../routing/Routing'
import affirm from '../../core/Affirm'

interface IPiPConfig {
    content: React.ReactNode
    metadata: { [key: string]: any }
}

interface IPiPService {
    open: (options: IPiPConfig) => void
    close: () => void
    restore: () => void
}

export const pip: IPiPService = {
    open: null,
    close: null,
    restore: null
}

function PiPService() {
    const theme = useTheme()
    const dispatch = useDispatch()
    const currentRoute = useAppSelector(s => s.session.currentRoute)
    const routeParams = useAppSelector(s => s.session.routeParams)
    const [open, setOpen] = useState(false)
    const [content, setContent] = useState<React.ReactNode>(null)
    const [initialRoute, setInitialRoute] = useState<Route>(null)
    const [initialParams, setInitialParams] = useState(null)
    const [metadata, setMetadata] = useState<{ [key: string]: any }>(null)

    useEffect(() => {
        pip.open = openPiP
        pip.close = closePiP
        pip.restore = restorePiP
    }, [currentRoute, routeParams])

    const openPiP = ({ content, metadata }: IPiPConfig) => {
        setContent(content)
        setInitialRoute(currentRoute)
        setInitialParams(routeParams)
        setMetadata(metadata)
        setOpen(true)
    }

    const closePiP = () => {
        setContent(null)
        setInitialRoute(null)
        setInitialParams(null)
        setMetadata(null)
        setOpen(false)
    }

    const restorePiP = () => {
        affirm(initialRoute, 'Initial Route not valid')

        dispatch(changeRoute({ route: initialRoute, params: { ...initialParams, metadata: metadata } }))
        closePiP()
    }

    if (!open) return null
    return (
        <Box
            sx={{
                position: 'fixed',
                overflow: 'hidden',
                zIndex: 999,
                bottom: theme.spacing(4),
                right: theme.spacing(4),
                width: '380px',
                height: 'auto',
                border: '1px solid var(--border-color)',
                boxShadow: '0px 0px 12px rgba(0,0,0,0.3)',
                background: theme.palette.background.smartable,
                borderRadius: theme.spacing(1),
                padding: theme.spacing(1)
            }}>
            <Box display='flex' justifyContent='flex-end'>
                <IconButton onClick={restorePiP} size='small'>
                    <PictureInPictureIcon />
                </IconButton>
                <IconButton onClick={closePiP} size='small'>
                    <CloseIcon />
                </IconButton>
            </Box>
            {content}
        </Box>
    )
}

export default PiPService
